import React from "react";
import {
  useParams
} from "react-router-dom";
import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import HistoryForm from '../components/HistoryForm'

const InterventionUpdate = () => {
  const { id } = useParams();

  return (
    <MainLayout>
      <UserInfos/>
      <h1 className="text-4xl font-semibold text-gray-800 dark:text-white">Dossier Immatriculation</h1>
      <h2 className=" text-gray-400">Mise à jour du dossier</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
        <div className="col-span-2">
        <HistoryForm id={id} />
        </div>
      </div>
    </MainLayout>
  );
}

export default InterventionUpdate
